import {TheRave} from "../../TheRave";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Layers, TheRaveLayers} from "../../view/TheRaveLayers";
import {gsap, TimelineLite} from "gsap";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {IBetWayWinData} from "../../server/data/ITheRaveData";
import {TheRaveSymbol} from "../../symbol/TheRaveSymbol";
import {MathHelper} from "../../../core/utils/MathHelper";
import {TheRaveGameAssets} from "../../TheRaveGameAssets";
import {BitmapText} from "pixi.js";
import {FontStyleConfig} from "../../config/FontConfig";

export class IndividualWinView {

    private _layer:StageLayer;
    private _playingGlow:PIXI.spine.Spine[] = [];
    private readonly _maxWinNumberWidth:number = 130;

    constructor() {
        this._layer = TheRaveLayers.getLayer(Layers.WIN_PRESENTATIONS)!;

        //const glow:PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("individualWin"));
        //TheRaveHelper.logSpineAndAnimations(glow, "Individual Win Glow");
        //const shadow:PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("individualShadow"));
        //TheRaveHelper.logSpineAndAnimations(shadow, "Individual Win Shadow");
    }

    public playAnimation(position:PIXI.Point, symHeight:number, doubleReel:number):TimelineLite {
        this._playingGlow = [];
        const tl = new TimelineLite();
        if(symHeight > 75) {

            const shadow:PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("individualShadow"));
            shadow.name = "individualShadow";
            shadow.position.set(position.x, position.y);
            this._playingGlow.push(shadow);
            tl.add([
                () => {
                    this._layer.addChild(shadow);
                    shadow.state.setAnimation(0, (symHeight > 300) ? "450" : symHeight.toString(), false);
                },
            ], 0);
            tl.add(() => this.recycleEffect(shadow), 1.26);
        }
        const glow:PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset("individualWin"));
        glow.name = "individualWin";
        glow.position.set(position.x, position.y);

        //console.log("ALL GLOW SPINE ANIMATIONS:", glow.spineData.animations)
        this._playingGlow.push(glow);
        tl.add([
            () => {
                this._layer.addChild(glow);
                glow.state.setAnimation(0, (symHeight > 300) ? "450" : symHeight.toString(), false);
            },
        ], 0);
        tl.add(() => this.recycleEffect(glow), 1.26);

        return tl;
    }

    public findLastNoWildSymbolPosition(betWayWinData:IBetWayWinData):number[] {
        for(let win = betWayWinData.reelWinPositions.length - 1; win > -1; win--) {


            const pos = betWayWinData.reelWinPositions[win],
                sym:TheRaveSymbol = TheRave.reels[pos[0]].getSymbol(pos[1]);
            if(!sym) {
                continue;
            }

            if(sym.name === "W") {
                continue;
            }
            return pos;

        }
        debugger
        return [0, 0];
    }

    private getStartPosition(symPosition:number[], textWidth:number):number[] {
        const reelId = symPosition[0],
            symId = symPosition[1],
            sym:TheRaveSymbol = TheRave.reels[reelId].getSymbol(symId);

        const viewPosition:PIXI.Point = TheRave.reels[reelId].getSymbol(symId, false, false).getStagePosition();
        let x = viewPosition.x;
        return [x, sym.position.y + 200, 150];
    }

    public playWinNumbers(betWayWinData:IBetWayWinData, skipped:boolean, symPosition:number[]):TimelineLite {
        let text = TheRave.apiPlugin.currency.formatValue(MathHelper.roundToDecimals(betWayWinData.amount, 2)),
            totalWinWays:number = betWayWinData.numberOfCombinations;
        if(betWayWinData.multiplier > 1) {
            text += ` x ${betWayWinData.multiplier}`;
        }
        let startScale = 1;
        let lingerTime = 0.4;
        const textHolder:PIXI.Sprite = new PIXI.Sprite();
        const winNumber = new PIXI.BitmapText(text, {
                fontName : TheRaveGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize : 8
            }),
            waysNumber = new BitmapText(totalWinWays.toString(), {
                fontName : TheRaveGameAssets.BITMAP_FONT_WAYS,
                fontSize : 12,
                tint : 0xffffff
            }),
            waysText = new PIXI.Text(`Way${totalWinWays > 1 ? "s" : ""}`, FontStyleConfig.WAYS_WON);
        winNumber.anchor = new PIXI.Point(0.5, 0.5);
        winNumber.position.set(0, 0);

        waysNumber.anchor = new PIXI.Point(1, 0.5);
        waysText.scale.set(0.4);
        waysText.anchor = new PIXI.Point(0, 0.5);
        waysNumber.letterSpacing = -6;

        textHolder.alpha = 0;
        textHolder.visible = false;
        textHolder.addChild(winNumber, waysText, waysNumber);
        textHolder.anchor.set(0.5, 0.5);
        this._layer.addChild(textHolder);
        winNumber.updateTransform();
        if(winNumber.width > this._maxWinNumberWidth) {
            const scale:number = MathHelper.roundToDecimals(this._maxWinNumberWidth / winNumber.width, 2);
            winNumber.scale.set(scale);
        }
        waysNumber.position.set(-5, 35);
        waysText.position.set(0, 35);
        const startPositions = this.getStartPosition(symPosition, winNumber.width);
        textHolder.position.set(startPositions[0], startPositions[1]);

        const timeline = gsap.timeline();
        timeline.add([
            () => {textHolder.visible = true;},
            gsap.to(textHolder, {duration : 0, alpha : 1}),
            gsap.to(textHolder, {duration: 0.8, alpha: 1})
        ], 0);
        timeline.add(gsap.to(textHolder, {duration : 0.4, alpha : 0, delay : lingerTime}));
        timeline.add(() => {
            if(winNumber.parent) {
                this._layer.removeChild(winNumber);
            }
            winNumber.destroy();
            if(waysNumber.parent) {
                this._layer.removeChild(waysNumber);
            }
            waysNumber.destroy();
            waysText.destroy();
            textHolder.destroy();
        });
        if(skipped) {
            timeline.timeScale(4);
        }
        return timeline;
    }


    private recycleEffect(glow:PIXI.spine.Spine):void {
        glow.state.setEmptyAnimation(0, 0);
        this._layer.removeChild(glow);
        ArrayHelper.removeFirstMatchElement(this._playingGlow, glow);
    }

    public stop():void {
        this._playingGlow.forEach(e => this.recycleEffect(e));
    }
}